import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { PackageProductCard as SharedUIPackageProductCard } from '@shared-ui/lodging-property-listing';
export const PackageProductCard = inject('context', 'multiItem', 'experiment', 'searchCriteria', 'searchResults', 'analyticsSearch', 'pageLayout')(observer(({
  context,
  multiItem,
  searchCriteria,
  searchResults,
  analyticsSearch
}) => {
  if (!context || !searchCriteria || !searchResults || !analyticsSearch || searchResults.isLoading) {
    return null;
  }
  const showDefaultFlightCard = multiItem === null || multiItem === void 0 ? void 0 : multiItem.isPackageShoppingPath();
  return React.createElement(React.Fragment, null, showDefaultFlightCard && React.createElement("div", {
    "data-stid": "package-product-card"
  }, React.createElement(SharedUIPackageProductCard, {
    data: searchResults
  })));
}));
PackageProductCard.displayName = 'PackageProductCard';